import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import {
  EntityDireccionesGeograficaIDEState,
  entityDireccionesGeograficaIDEAdapter
} from './entity-direcciones-geografica-ide.state';

const { selectEntities, selectAll } =
  entityDireccionesGeograficaIDEAdapter.getSelectors();

export const getError = (state: EntityDireccionesGeograficaIDEState): any =>
  state.error;

export const getIsLoading = (
  state: EntityDireccionesGeograficaIDEState
): boolean => state.isLoading;

export const selectDireccionesGeograficaIDEState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.direccionesGeograficaIDE
);

export const selectAllDireccionesGeograficaIDE = createSelector(
  selectDireccionesGeograficaIDEState,
  selectAll
);

export const selectEntitiesDireccionesGeograficaIDE = createSelector(
  selectDireccionesGeograficaIDEState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectDireccionesGeograficaIDEError = createSelector(
  selectDireccionesGeograficaIDEState,
  getError
);

// MemoizedSelector<object,any>
export const selectDireccionesGeograficaIDEIsLoading = createSelector(
  selectDireccionesGeograficaIDEState,
  getIsLoading
);
